(() => {
  function placeBuyboxAccordions() {
    const main = document.querySelector('.cc-main-product');
    const usps = main?.querySelector('.product-usps');
    if (!usps) return;
    let container = main.querySelector('.sbs-buybox-accordions');
    if (!container) {
      container = document.createElement('div');
      container.className = 'sbs-buybox-accordions';
      usps.after(container);
    }
    const payment = document.querySelector('[data-buybox-payment]');
    if (payment && !container.contains(payment)) {
      const oldWrapper = payment.parentElement;
      const summary = payment.querySelector('summary');
      const icon = document.createElement('span');
      icon.className = 'sbs-buybox-accordion-icon';
      icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18M7 15h4"/></svg>';
      summary.prepend(icon);
      container.append(payment);
      if (oldWrapper.classList.contains('product-details__block') && !oldWrapper.children.length) oldWrapper.hidden = true;
    }
    const priceMatch = document.querySelector('.sbs-price-match-footer .sbs-price-match');
    if (priceMatch) {
      const title = priceMatch.querySelector('strong');
      const oldWrapper = priceMatch.parentElement;
      const details = document.createElement('details');
      details.className = 'sbs-description-accordion';
      const summary = document.createElement('summary');
      const icon = priceMatch.querySelector('svg');
      if (icon) summary.append(icon);
      summary.append(document.createTextNode(title?.textContent || 'Price match guarantee'));
      title?.remove();
      const message = priceMatch.querySelector('p > span');
      if (message) message.textContent = message.textContent.replace(/^\s*—\s*/, '');
      const formLink = priceMatch.querySelector('.sbs-price-match__button');
      if (message && formLink) message.parentElement.append(document.createTextNode(' '), formLink, document.createTextNode('.'));
      const body = document.createElement('div');
      body.className = 'sbs-description-accordion__body';
      body.append(priceMatch);
      details.append(summary, body);
      container.append(details);
      oldWrapper.hidden = true;
    }
    container.hidden = !container.children.length;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeBuyboxAccordions);
  else placeBuyboxAccordions();
  document.addEventListener('shopify:section:load', placeBuyboxAccordions);
})();
